import React, { useState } from "react";
import { HttpService } from "../../apiAuthorization/httpService";

export const User = React.createContext(null);

export const UserContext = props => {
    const [userInfo, setUserInfo] = useState(null);
    const [userDetail, setUserDetail] = useState(null);

    const getUserInfo = () => {
        HttpService.post("/Home/GetUserInfo")
        .then((result) => {
            setUserInfo(result);
        },
        (error) => {
            console.log(error);
        })
    };

    const getCurrentUserDetails = () => {
        HttpService.post("/Home/GetCurrentUserDetails")
        .then((result) => {
            setUserDetail(result);
        },
        (error) => {
            console.log(error);
        })
    };

    const setUserHeadImage = (headImage) => {
        setUserInfo({ ...userInfo, HeadImage: headImage });
    };

    const contextValue = {
        userInfo, userDetail, getUserInfo, getCurrentUserDetails, setUserHeadImage
    };

    return (
        <>
            <User.Provider value={contextValue}>
                {props.children}
            </User.Provider>
        </>
    );
}
